import React from "react";
import { Elements, UI } from "@yoopta/editor";
import { RowSpacingIcon, SizeIcon, WidthIcon } from "@radix-ui/react-icons";

const CheckmarkIcon = ({ width = 16, height = 16, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const DownloadIcon = ({ width = 16, height = 16, className = "" }) => (
  <svg
    viewBox="0 0 16 16"
    style={{
      width: `${width}px`,
      height: `${height}px`,
      display: "block",
      fill: "rgba(55, 53, 47, 0.85)",
      flexShrink: 0,
    }}
    className={className}
  >
    <path d="M8.215 15.126c3.862 0 7.061-3.192 7.061-7.062 0-3.862-3.199-7.061-7.068-7.061-3.862 0-7.055 3.2-7.055 7.061 0 3.87 3.2 7.062 7.062 7.062zm0-1.388a5.654 5.654 0 01-5.667-5.674 5.642 5.642 0 015.66-5.667 5.66 5.66 0 015.68 5.667 5.66 5.66 0 01-5.673 5.674zm0-9.174c-.342 0-.602.247-.602.588v3.234l.062 1.401-.622-.766-.766-.8a.557.557 0 00-.41-.177.54.54 0 00-.56.547c0 .164.054.3.163.41l2.256 2.283c.15.157.294.226.479.226.191 0 .335-.075.485-.226l2.256-2.283a.557.557 0 00.164-.41.539.539 0 00-.56-.547.523.523 0 00-.41.178l-.766.793-.622.779.054-1.408V5.152c0-.341-.253-.588-.601-.588z"></path>
  </svg>
);

const { ExtendedBlockActions, BlockOptionsMenuGroup, BlockOptionsMenuItem, BlockOptionsSeparator } = UI;

const ImageBlockOptions = ({ editor, block, props: imageProps }) => {
  const onCover = () => {
    Elements.updateElement(editor, block.id, {
      type: "image",
      props: { fit: "cover" },
    });
  };

  const onFit = () => {
    Elements.updateElement(editor, block.id, {
      type: "image",
      props: { fit: "contain" },
    });
  };

  const onFill = () => {
    Elements.updateElement(editor, block.id, {
      type: "image",
      props: { fit: "fill" },
    });
  };

  const onDownload = () => {
    if (!imageProps || !imageProps.src) return;

    const link = document.createElement("a");
    link.href = imageProps.src;
    link.download = imageProps.alt || imageProps.src;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ExtendedBlockActions
      onClick={() => editor.setPath({ current: block.meta.order })}
      className="yoopta-image-options"
    >
      <BlockOptionsSeparator />
      <BlockOptionsMenuGroup>
        <BlockOptionsMenuItem>
          <button
            type="button"
            className="yoopta-block-options-button"
            onClick={onFit}
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <RowSpacingIcon className="yoo-editor-w-4 yoo-editor-h-4 yoo-editor-mr-2" />
              Fit
            </div>
            {imageProps?.fit === "contain" && <CheckmarkIcon className="yoo-editor-w-4 yoo-editor-h-4" />}
          </button>
        </BlockOptionsMenuItem>
        <BlockOptionsMenuItem>
          <button
            type="button"
            className="yoopta-block-options-button"
            onClick={onFill}
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <WidthIcon className="yoo-editor-w-4 yoo-editor-h-4 yoo-editor-mr-2" />
              Fill
            </div>
            {imageProps?.fit === "fill" && <CheckmarkIcon className="yoo-editor-w-4 yoo-editor-h-4" />}
          </button>
        </BlockOptionsMenuItem>
        <BlockOptionsMenuItem>
          <button
            type="button"
            className="yoopta-block-options-button"
            onClick={onCover}
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <SizeIcon className="yoo-editor-w-4 yoo-editor-h-4 yoo-editor-mr-2" />
              Cover
            </div>
            {imageProps?.fit === "cover" && <CheckmarkIcon className="yoo-editor-w-4 yoo-editor-h-4" />}
          </button>
        </BlockOptionsMenuItem>
      </BlockOptionsMenuGroup>
      <BlockOptionsSeparator />
      <BlockOptionsMenuGroup>
        <BlockOptionsMenuItem>
          <button type="button" className="yoopta-block-options-button" onClick={onDownload}>
            <DownloadIcon className="yoo-editor-w-4 yoo-editor-h-4 yoo-editor-mr-2" />
            Download
          </button>
        </BlockOptionsMenuItem>
      </BlockOptionsMenuGroup>
    </ExtendedBlockActions>
  );
};

export { ImageBlockOptions };
